export default "__VITE_ASSET__CvIekksF__"